<template>
  <div class="reset-dialog-wrapper">
    <div class="reset-dialog-content">
      <h1>{{ $t('PUBLISHING.DETAIL.PRODUCTS.UNSUPPORTED.DIALOG.HEADING') }}</h1>
      <p>
        {{ $t('PUBLISHING.DETAIL.PRODUCTS.UNSUPPORTED.DIALOG.SUBHEADING') }}
      </p>
      <ul>
        <li>
          <Icon icon="sprd-heart" />
          {{ $t('PUBLISHING.DETAIL.PRODUCTS.UNSUPPORTED.DIALOG.BENEFIT1') }}
        </li>
        <li>
          <Icon icon="sprd-heart" />
          {{ $t('PUBLISHING.DETAIL.PRODUCTS.UNSUPPORTED.DIALOG.BENEFIT2') }}
        </li>
        <li>
          <Icon icon="sprd-heart" />
          {{ $t('PUBLISHING.DETAIL.PRODUCTS.UNSUPPORTED.DIALOG.BENEFIT3') }}
        </li>
      </ul>
    </div>

    <Warning
      heading="PUBLISHING.DETAIL.PRODUCTS.UNSUPPORTED.DIALOG.WARNING.HEADING"
      subheading="PUBLISHING.DETAIL.PRODUCTS.UNSUPPORTED.DIALOG.WARNING.SUBHEADING"
    />
    <div class="actions">
      <ProgressButton
        class="btn btn-lg btn-primary"
        label="PUBLISHING.DETAIL.PRODUCTS.UNSUPPORTED.DIALOG.CTA"
        @click="reset"
      />
      <button class="btn btn-lg btn-ghost" @click="cancel">
        {{ $t('PUBLISHING.DETAIL.PRODUCTS.UNSUPPORTED.DIALOG.CANCEL') }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import ProgressButton from 'commons/btnProgress/ProgressButton.vue';
import Warning from 'src/app/components/warnings/Warning.vue';
import { useCompositionStore } from 'commons/stores/composition';
import { CompositionMode } from '@spreadgroup/common-partner-lib/composition';

const compositionStore = useCompositionStore();

const props = defineProps<{
  modalInstance: any;
  data: any;
}>();

const reset = async () => {
  try {
    await compositionStore.resetToMode(CompositionMode.SMART);
    props.modalInstance.close();
  } catch (_) {
    // nothing
  }
};

const cancel = () => {
  props.modalInstance.dismiss();
};
</script>

<style lang="scss" scoped>
@import 'src/scss/constants';
@import 'src/scss/styleguide/colors';

.reset-dialog-wrapper {
  display: flex;
  flex-direction: column;
  gap: 32px;
  max-width: 600px;
}

.reset-dialog-content {
  display: flex;
  flex-direction: column;
  gap: 16px;

  h1,
  p {
    margin: 0;
    padding: 0;
  }

  ul {
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 8px;

    li {
      display: flex;
      align-items: center;
      gap: 16px;

      .icon {
        width: 20px;
        height: 20px;
      }
    }
  }
}

.actions {
  display: flex;
  gap: 16px;

  .btn {
    flex: 1;
  }
}
</style>
